import React from "react";
import Lagerkonfigurator from "../Lagerkonfigurator";
import Foerderrechner from "../../Foerderrechner";
import PLZSearch from "../PlzSearch";
import Pelletheizung3DIframe from "../../Pelletsheizung3D";
import SurveyIframe from "../../SurveyIframe";

const navigationConfig = [
  {
    title: "Das Institut",
    items: [
      {
        label: "Über das DEPI",
        link: "ueber-das-depi",
        uuid: "3a027484-274b-4a22-bfcf-17e3b4eb7c27"
      },
      {
        label: "Branchenunternehmen",
        link: "branchenunternehmen"
      },
      {
        label: "Termine",
        link: "termine"
      },
      {
        label: "KampagneThema",
        link: "unsere-heizung",
        path: "unsere-heizung/:theme",
        hideInNav: true
      },
      {
        label: "Kampagne",
        link: "unsere-heizung",
        path: "unsere-heizung",
        hideInNav: true
      },
      {
        label: "welche heiung",
        link: "welche-heizung",
        uuid: "679f1077-6422-40ba-994b-e344613c28d1",
        hideInNav: true,
        children: [<SurveyIframe key="survey" />]
      }
    ]
  },
  {
    title: "Heizen mit Pellets",
    items: [
      {
        label: "Pelletproduktion",
        link: "pelletproduktion",
        uuid: "260981dd-3d9c-4604-a3ab-a6493cb25e7c"
      },
      {
        label: (
          <span>
            EN<i>plus</i>-Qualitätssicherung
          </span>
        ),
        link: "enplus-qualitaetssicherung",
        uuid: "25704679-bade-47cc-aa9d-6c48148bde19"
      },
      {
        label: "Pelletpreis / Wirtschaftlichkeit",
        link: "pelletpreis-wirtschaftlichkeit",
        uuid: "348c10f2-8368-49ab-b2fb-5bb01627d8a1"
      },
      {
        label: "Pelletheizsysteme",
        link: "pelletheizsysteme",
        uuid: "ae9c8efd-8989-4ea2-b9d5-62a2a9bcbdad",
        items: [
          {
            label: "Effizienz",
            link: "pelletheizsysteme/effizienz",
            uuid: "a6fdbf21-8f3d-4464-ba78-335459854136"
          },
          {
            label: "Komfort",
            link: "pelletheizsysteme/komfort",
            uuid: "621fb622-540c-4fa6-bec0-d533f1a4099c"
          },
          {
            label: "Pelletheizung 3D",
            link: "pelletheizung-3d",
            uuid: "e0b0d7de-1dcb-40fa-bc8b-a69eb6d5eafe",
            children: [<Pelletheizung3DIframe key="pelletheizung-3d" />]
          }
        ]
      },
      {
        label: "Pelletlager",
        link: "pelletlager",
        uuid: "13f99d0d-e777-4a68-9ad6-eadc11d7294a",
        children: [<Lagerkonfigurator key="konfigurator" />]
      },
      {
        label: "Klima und Umwelt",
        link: "klima-und-umwelt",
        uuid: "08bfbeb9-abca-4f44-aee2-96fcd7e02bd4",
        items: [
          {
            label: 'Studie "Klimaholz"',
            link: "studie-klima-holz",
            uuid: "9b07395c-7f2c-47c6-89eb-b4fc7687bf1a"
          }
        ]
      },
      {
        label: "Pelletbotschafter",
        link: "pelletbotschafter"
      },
      {
        label: "Historie",
        link: "historie",
        uuid: "6d963e4f-c886-475e-b489-218efe4da52d"
      }
    ]
  },
  {
    title: "Für Verbraucher",
    items: [
      {
        label: "Fachbetriebe und Ofenstudios",
        link: "pelletfachbetriebe-und-ofenstudios",
        uuid: "d3ae6f24-153b-44da-9f35-192048e47c22",
        children: [<PLZSearch key="search" />]
      },
      {
        label: (
          <span>
            EN<i>plus</i>-Händler
          </span>
        ),
        link:
          "https://enplus-pellets.de/unternehmen-finden?&groupFilters=dealer_certificate&q=",
        external: true
      },
      {
        label: "Förderprogramme",
        link: "foerderprogramme",
        uuid: "6ff5c8d5-3ede-425b-a16e-359b3f3d4f0e",
        children: [<Foerderrechner key="rechner" />],
        items: [
          {
            label: "Förderprogramme nach Bundesländern",
            link: "foerderprogramme/foerderprogramme-nach-bundeslaendern",
            uuid: "594842e1-9e76-4110-880a-eacde16b2f9a"
          }
        ]
      },
      {
        label: "Verbraucherreferenzen",
        link: "verbraucherreferenzen"
      },
      {
        label: "Newsletter",
        link: "newsletter"
      },
      {
        label: "FAQ",
        link: "faq",
        uuid: "ac136f2e-18b7-480b-b656-7de872a1f2b8"
      },
      {
        label: "Pelletlexikon",
        link: "pelletlexikon",
        uuid: "58fbbfd3-51da-487b-90a5-4e5fa3380478"
      }
    ]
  },
  {
    title: "Für Fachleute",
    items: [
      {
        label: "Informationen für Fachleute",
        link: "informationen-fuer-fachleute",
        uuid: "27168863-61ab-411b-8940-6a9aa6ba62df"
      },
      {
        label: "E-Learning für Azubis",
        link: "https://www.grüne-wärme.info",
        external: true,
        hideInNav: true
      },
      {
        label: "Pelletfachbetrieb werden",
        link: "pelletfachbetrieb-werden",
        uuid: "17ff481e-61af-446e-93e8-6c7f02170acb"
      },
      {
        label: "Fachstudio für Pelletkaminöfen werden",
        link: "fachstudio-pelletkaminofen-werden",
        uuid: "22e2a74a-fbcf-4be3-bc69-75bf409c346b"
      },
      {
        label: "Schulungen",
        link: "schulungen",
        uuid: "da9ae1c9-0132-45fe-8579-435e4de6187c"
      },
      {
        label: "Newsletter",
        link: "newsletter-intern",
        internal: true
      },
      {
        label: "Veranstaltungen",
        link: "veranstaltungen",
        internal: true
      },
      {
        label: "Schulungsvorträge",
        link: "schulungsvortraege",
        internal: true
      },
      {
        label: "Marketingmaterial / Vorlagen",
        link: "marketingmaterial",
        internal: true,
        uuid: "ced53c0f-8ed5-43e3-85b2-b5643503416c"
      },
      {
        label: "Fachinformationen",
        link: "fachinformationen",
        internal: true
      },
      {
        label: "Rabatte",
        link: "rabatte",
        internal: true,
        uuid: "fc2d641c-cbc1-418d-8a17-d907ff7e53df"
      }
    ]
  },
  [
    {
      title: "Mediathek",
      items: [
        {
          label: "Mediathek",
          link: "mediathek"
        }
      ]
    },
    {
      title: "Presse",
      items: [
        {
          label: "News und Pressemitteilungen",
          link: "news-und-pressemitteilungen"
        },
        {
          label: "Pressebilder",
          link: "pressebilder"
        },
        {
          label: "Interviews",
          link: "interviews"
        },
        {
          label: "Kurzreportagen",
          link: "kurzreportagen"
        },
        {
          label: "Presseveranstaltungen",
          link: "presseveranstaltungen",
          hideInNav: true
        }
      ]
    }
  ],
  {
    title: "Kontakt",
    mobileTitle: "Kontakt und Impressum",
    items: [
      {
        label: "Kontakt",
        link: "kontakt"
      },
      {
        label: "Impressum",
        link: "impressum",
        uuid: "99dd17b8-90ab-42de-9f07-89cea5003396"
      },
      {
        label: "Datenschutz",
        link: "datenschutz",
        uuid: "2fbbd3c5-adce-4b58-a72d-fd80108c01e1"
      },
      {
        label: "DEPI-Shop",
        link: "https://depi.de/shop",
        external: true
      }
    ]
  }
];

export default navigationConfig;
